import { Component, OnInit, EventEmitter, ViewChild, Output, OnChanges, Input, OnDestroy, QueryList, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { PhBhpFilterComponent } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/ph-bhp-filter/ph-bhp-filter.component';
import { Subscription } from 'rxjs';
import { SopDetail } from 'ph-bhp-feature-packages/ph-bhp-feature-package-elearning/lib/Models';
import { asepticProcedures } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/ph-bhp-asepticprocedures.service';
import { PHBHPFeaturePackageEvaluationService } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/public_api';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { AppConfig } from 'src/app/app.config';
import { PHBHPFeaturePackageEvaluationFilterService } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/ph-bhp-feature-package-evaluationfilter.service';
import { TranslationKeys } from 'ph-bhp-localization';
import { PhBhpPdfComplianceMultiFilterComponent } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/ph-bhp-pdf-compliance-multi-filter/ph-bhp-pdf-compliance-multi-filter.component';
import { PhBhpBarChartComponent } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/ph-bhp-bar-chart/ph-bhp-bar-chart.component';
import { PhBhpPdfComplianceMultiFilterObserveComponent } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/ph-bhp-pdf-compliance-multi-filter-observe/ph-bhp-pdf-compliance-multi-filter-observe.component';
import cloneDeep from 'lodash/cloneDeep';
import { PhBhpObserveChartExportComponent } from '../ph-bhp-observe-chart-export/ph-bhp-observe-chart-export.component';

@Component({
  selector: 'lib-ph-bhp-observe-statistics-before-aseptic-procedures',
  templateUrl: './ph-bhp-observe-statistics-before-aseptic-procedures.component.html',
  styleUrls: ['./ph-bhp-observe-statistics-before-aseptic-procedures.component.css']
})
export class PhBhpObserveStatisticsBeforeAsepticProceduresComponent implements OnInit, OnChanges, OnDestroy {
  private static readonly INITIAL_FIELDS = [
    { 'field': 'name', 'title': 'CONFIGURE.DESCRIPTION' }
  ];
  langSubscription: Subscription;
  userSubscription: Subscription;
  institutionSubscription: Subscription;
  compareCard;
  tempFilter;
  showCompareCard;
  singleCard;
  data
  filterDetails = [];
  isDesktop = true;
  isAdjustableHeight = true;
  @ViewChild('compliance', { static: true }) compliance: PhBhpPdfComplianceMultiFilterObserveComponent;
  @ViewChild('exportTag', { static: true }) exportTag: PhBhpObserveChartExportComponent;
  @ViewChildren(PhBhpBarChartComponent) charts: QueryList<PhBhpBarChartComponent>;
  @ViewChildren(PhBhpFilterComponent) filters: QueryList<PhBhpFilterComponent>;
  initFlag = true;
  sopiDs: Array<any> = [];
  isSavedFromEvaluation: boolean;
  noDataFound: boolean = false;
  percentageLegend = "{0}%";
  textLegend: string;
  complianceType;
  labels;

  pageInfo = {
    ofLabel: 'GENERAL.OF',
    items: 'GENERAL.ITEMS',
    itemsPerPageLabel: 'GENERAL.ITEMS_PAGE'
  };

  dataMoments = [];
  isCallFor;
  sopDetail: SopDetail[];
  pageTitle: string;
  userID: number;
  roleId: number;
  appName = 'Observe';
  translationKeys: typeof TranslationKeys = TranslationKeys;
  filterIndices: number[] = [0];

  public clickImageBtn = false;
  public clickExcelBtn = false;
  public clickPdfBtn = false;

  evaluationLoaded: boolean = false;
  isBenchmark: boolean = false;
  asepticProcedures = asepticProcedures;
  originalData: any;
  asepticProceduresResponse: any;
  isEvaluationTable: boolean = true;
  isUserFilterSetted: boolean = false;
  userHasFilter: boolean = false;

  multiSelectText: string = '';
  results: any = [];
  userFilters: any;
  sopFilters: any[] = [];

  constructor(
    public appConfig: AppConfig,
    private router: Router,
    private evaluationService: PHBHPFeaturePackageEvaluationService,
    private layoutService: PHBHPLayoutPackageService,
    private filterService: PHBHPFeaturePackageEvaluationFilterService) {
    this.textLegend = this.layoutService.translateText("EVALUATION.PERCENT_COMPLIANCE");
    this.appConfig.filterDetails ? this.filterDetails = this.appConfig.filterDetails : this.filterDetails = [];
  }

  ngOnInit(): void {
    this.userID = this.appConfig.userData.userId;
    this.roleId = this.appConfig.userData.roleName.roleId;
    this.langSubscription = this.layoutService.lang.asObservable().subscribe((changelang) => {
      setTimeout(() => {
        for (let i = 0; i < this.charts.length; i++) {
          let chart = this.charts.get(i);
          chart.chartOptions.valueAxis.title.text = this.textLegend;
        }

        this.pageTitle = this.layoutService.translateText('OBSERVATION.BEFORE.ASEPTIC_TASK');
        this.compliance.complianceTitle = this.layoutService.translateText('OBSERVATION.BEFORE.ASEPTIC_TASK');

        //Generate again labels for charts and tables
        this.evaluate(true);
        
        this.layoutService.showLoader = false;
      }, 1000);
    });

    this.pageTitle = this.layoutService.translateText('OBSERVATION.BEFORE.ASEPTIC_TASK');
    this.compliance.complianceTitle = this.layoutService.translateText('OBSERVATION.BEFORE.ASEPTIC_TASK');
    this.ngOnChanges();
  }

  ngOnChanges() {
    this.layoutService.showLoader = true;
    this.userHasFilter = false;
    if (!this.isUserFilterSetted) {
      this.evaluationService.getUserHasObserveEvaluationFilter(this.appConfig.userData.userId, 'aseptic procedure').subscribe((userHasFilter) => {
        this.isUserFilterSetted = true;
        if (userHasFilter) {
          this.userHasFilter = true;
          this.userFilters = JSON.parse(userHasFilter.filterList);
          this.userFilters = this.userFilters.Filter;
          setTimeout(() => { this.initComponent(); });
        } else {
          this.userFilters = [];
          this.noDataFound = true;
          this.filters.get(0).showFilter(true);
          this.compliance.resultsLoader.next([{}]);
        }
      }, (error) => { }, () => { this.layoutService.showLoader = false; });
    } else {
      setTimeout(() => { this.initComponent(); });
    }
  }

  ngOnDestroy() {
    if (this.langSubscription)
      this.langSubscription.unsubscribe();
    if (this.userSubscription)
      this.userSubscription.unsubscribe();
    if (this.institutionSubscription)
      this.institutionSubscription.unsubscribe();
  }

  initComponent() {
    if (this.userFilters.length > 0) {
      this.userFilters.forEach((filter, idx) => {
        if (!filter.filterName || filter.filterName.trim() === "") {
          filter.filterName = this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (idx + 1);
        }
      });
      this.filterIndices = this.userFilters.map((_, index) => index);
      this.showCompareCard = this.filterIndices.length > 1;
    }

    if (this.appConfig.userData) {
      for (let i = 0; i < this.charts.length; i++) {
        let chart = this.charts.get(i);
        chart.chartOptions.valueAxis.labels = {
          format: this.percentageLegend
        };
        chart.chartOptions.valueAxis.title = {
          text: this.layoutService.translateText('OBSERVATION.BEFORE.ASEPTIC_TASK'),
          font: "9px OpenSans-Regular"
        };
      }

      this.compliance.showFilter = true;
      this.compliance.complianceTitle = this.pageTitle;
      this.compliance.roleId = this.roleId;
      this.compliance.fillWith = 'N/A';
      this.loadFiltersInfo();
      if (this.userFilters && this.userFilters.length >= 2 && this.isDesktop) {
        this.showCompareCard = this.filterIndices.length > 1;
        this.compliance.showCompareCard = this.showCompareCard;
        this.tempFilter = this.userFilters;
      }

      this.evaluate(true, true);
    }
  }

  evaluate(getResults, initialize?) {
    this.printConfig();
    const proceduresChecked = this.asepticProcedures.filter(procedure => procedure.checked).map(procedure => procedure.id);
    this.data = {
      filter: [],
      isBenchMark: true,
      asepticProceduresShown: proceduresChecked,
      roleId: this.roleId
    };


    if (initialize) {
      this.data.filter = this.userFilters;
    } else {
      this.filters.forEach((filter) => {
        let filterData: any = {
          startDate: filter.range.start,
          endDate: filter.range.end,
          instutionIDs: "",
          departmentID: "",
          wardID: "",
          professionalCategoryID: "",
          subprofessionalCategoryID: "",
          countryID: 0
        };

        if (this.roleId == 1 && filter.setCountry != 0) {
          filterData.countryID = filter.setCountry.countryID
        }

        filterData = filter.assignData(filterData);
        this.data.filter.push(filterData);
        if (filterData.multiSelectName) {
          this.multiSelectText = filterData.multiSelectName;
        }
      });
    }

    this.compliance.setFilters(this.filters.toArray());
    this.userHasFilter = true;
    if (getResults == true) {
      this.getAsepticFilterDetails(this.userID, this.data);
    } else if (getResults == false) {
      this.saveAsepticProceduresDetails(this.userID, this.data)
    }
  }

  async loadFiltersInfo() {
    setTimeout(() => {
      this.userFilters.forEach((filter, index) => {
        let filterComponent = this.filters.toArray()[index];
        let startDate = new Date(filter.startDate);
        startDate = new Date(startDate.getUTCFullYear(), startDate.getUTCMonth(), startDate.getUTCDate());
        let endDate = new Date(filter.endDate);
        endDate = new Date(endDate.getUTCFullYear(), endDate.getUTCMonth(), endDate.getUTCDate());
        filterComponent.dateRange = [startDate, endDate];
        filterComponent.selectDate();
        filterComponent.setFilterNameFilter(filter.filterName, true);
        if (this.roleId == 1) {
          filterComponent.setSAFilter(filter, true);
        } else {
          filterComponent.setCountryFilter(filter.CountryID, '', '', true);
          filterComponent.setInstitutionsByID(filter.instutionIDs, true);
          if (filterComponent.wardListLoaded) {
            filterComponent.onWardChange(filterComponent.wardListLoaded.find(ward => ward.wardID == filter.wardID));
          }

          filterComponent.setDepartmentFilter(filter.departmentID, true);
          filterComponent.setDepartmentTypeFilter(filter.departmentTypeID, true);
          filterComponent.setProfessionalCategory(filter.professionalCategoryID, filter.subprofessionalCategoryID, true);
          if (filter.multiselect) {
            filterComponent.setMultiFilter(filter.multiselect, filter.multiSelectFilter, filter.multiSelectValues, true);
          }
        }
      });
    }, 500);
  }

  resetExportAs(value: 'image' | 'excel' | 'pdf') {
    switch (value) {
      case 'image':
        this.clickImageBtn = false;
        break;
      case 'excel':
        this.clickExcelBtn = false;
        break;
      case 'pdf':
        this.clickPdfBtn = false;
        break;
    }
  }

  exportAs() {
    this.clickImageBtn = true;
  }

  excelDownload() {
    this.clickExcelBtn = true;
  }

  downloadKendoPDF() {
    this.clickPdfBtn = true;
  }

  filterCompare() {
    this.compareCard = false;

    if (this.filterIndices.length < 6) {
      this.filterIndices.push(this.filterIndices.length);
    }

    this.showCompareCard = this.filterIndices.length > 1;
    this.compliance.showCompareCard = this.showCompareCard;
    this.layoutService.showLoader = true;
    setTimeout(() => {
      var filters = this.filters.toArray();
      filters[filters.length - 1].setInfoFromFilter(cloneDeep(filters[filters.length - 2]));
      this.layoutService.showLoader = false;
    }, 500);

    if (!this.userHasFilter) {
      this.filters.get(0).showFilter(true);
      return;
    }
  }

  printConfig() {
    if (this.sopiDs.length == 0) {
      this.compliance.SOPList = this.sopiDs;
      this.compliance.SOPName = undefined;
    } else {
      this.compliance.SOPList = undefined;
      this.compliance.SOPName = this.data.translatetext("EVALUATION.All.SOP");
    }
  }

  showFilter(cardType) {
    const showFilter = cardType;
    if (showFilter == 'singleCard') {
      this.singleCard = !this.singleCard;
      this.compareCard = false;
    }
    if (showFilter == 'compareCard') {
      this.compareCard = !this.compareCard
      this.singleCard = false;
    }
  }

  cancelFilter() {
    this.singleCard = false;
    this.compareCard = false;
  }

  saveAsepticProceduresDetails(userID, data) {
    this.complianceType = "aseptic procedure";
    this.isSavedFromEvaluation = false;
    this.layoutService.showLoader = true;
    this.evaluationService.SaveSummarisedDetail(userID, this.isSavedFromEvaluation, this.complianceType, data).subscribe(res => {
      this.layoutService.showLoader = false;
      this.layoutService.showSuccess(this.layoutService.translateText("EVALUATION.SUCCESSFULLY_SAVED_SUMMARISED_REPORT"));
    })
  }

  getAsepticFilterDetails(userID, data) {
    this.complianceType = "aseptic procedure";
    this.isCallFor = "aseptic procedure";
    this.isSavedFromEvaluation = true;
    this.layoutService.showLoader = true;
    this.evaluationService.getAsepticDetailsMulti(userID, this.isSavedFromEvaluation, this.isCallFor, data).subscribe((res: any) => {
      this.layoutService.showLoader = false;
      this.originalData = JSON.parse(JSON.stringify(res));
      this.asepticProceduresResponse = res;
      this.buildChart(this.asepticProceduresResponse);
    })
  }

  updateAsepticProceduresShown(isSavedFromEvaluation, userID, data) {
    this.isSavedFromEvaluation = isSavedFromEvaluation;
    this.evaluationService.updateAsepticProceduresShown(userID, this.isSavedFromEvaluation, data).subscribe((res: any) => {
    })
  }

  setFilterDetails() {
    if (this.appConfig.filterDetails.length > 0) {
      if (this.filters) {
        this.filterService.setFiltersValue(this.filterDetails, this.filters.toArray());
      }
    }
  }

  createFilterData(userID) {
    const defaultFilterData = {
      startDate: new Date(),
      endDate: new Date(),
      instutionIDs: "",
      departmentID: "",
      wardID: "",
      professionalCategoryID: "",
      subprofessionalCategoryID: "",
      countryID: 0
    };

    const filters = this.filters && this.filters.length > 0 ? this.filters.map(filter => {
      let filterData = { ...defaultFilterData, startDate: filter.range.start, endDate: filter.range.end };
      if (this.roleId === 1 && filter.setCountry !== 0) {
        filterData.countryID = filter.setCountry.countryID;
      }
      return filter.assignData(filterData);
    }) : [defaultFilterData];

    return {
      filter: filters,
      countryID: 0,
      isBenchMark: true,
      userId: userID,
      isSavedFromEvaluation: true,
      asepticProceduresShown: this.asepticProcedures.filter(procedure => procedure.checked).map(procedure => procedure.id)
    };
  }

  updateFilters(filters) {
    this.filterIndices = filters.filter.map((_, index) => index);
    this.filters.toArray().forEach((filterComponent, index) => {
      if (filters.filter[index]) {
        let startDate = new Date(filters.filter[index].startDate);
        startDate = new Date(startDate.getUTCFullYear(), startDate.getUTCMonth(), startDate.getUTCDate());
        let endDate = new Date(filters.filter[index].endDate);
        endDate = new Date(endDate.getUTCFullYear(), endDate.getUTCMonth(), endDate.getUTCDate());
        filterComponent.dateRange = [startDate, endDate];
        filterComponent.selectDate();
        filterComponent.setCountryFilter(filters.filter[index].countryID, filters.filter[index].instutionIDs, filters.filter[index].wardID, true);
        filterComponent.setDepartmentFilter(filters.filter[index].departmentID, true);
        filterComponent.setDepartmentTypeFilter(filters.filter[index].departmentTypeID, true);
        filterComponent.setProfessionalCategory(filters.filter[index].professionalCategoryID, filters.filter[index].subprofessionalCategoryID, true);
      }
    });

    setTimeout(() => {
      this.compliance.setFilters(this.filters.toArray());
    }, 1000);

    this.printConfig();

    if (filters.filter.length >= 2 && this.isDesktop) {
      this.showCompareCard = this.filterIndices.length > 1;
      this.compliance.showCompareCard = this.showCompareCard;
      this.tempFilter = filters;
    }

    if (filters.asepticProceduresShown) {
      this.asepticProcedures.forEach(procedure => {
        procedure.checked = filters.asepticProceduresShown.includes(procedure.id);
      });
    }
  }

  ngAfterViewChecked() {
    if (this.tempFilter) {
      var tempFilter = this.tempFilter;
      this.tempFilter = undefined;

      this.userFilters.forEach((filter, index) => {
        let filterComponent = this.filters.toArray()[index];
        let startDate = new Date(filter.startDate);
        startDate = new Date(startDate.getUTCFullYear(), startDate.getUTCMonth(), startDate.getUTCDate());
        let endDate = new Date(filter.endDate);
        endDate = new Date(endDate.getUTCFullYear(), endDate.getUTCMonth(), endDate.getUTCDate());
        filterComponent.dateRange = [startDate, endDate];
        filterComponent.selectDate();
        if (this.roleId == 1) {
          filterComponent.setSAFilter(filter, true);
        } else {
          filterComponent.setCountryFilter(filter.CountryID, '', '', true);
          filterComponent.setInstitutionsByID(filter.instutionIDs, true);
          filterComponent.setDepartmentFilter(filter.departmentID, true);
          filterComponent.setDepartmentTypeFilter(filter.departmentTypeID, true);
          filterComponent.setProfessionalCategory(filter.professionalCategoryID, filter.subprofessionalCategoryID, true);
          if (filter.multiselect) {
            filterComponent.setMultiFilter(filter.multiselect, filter.multiSelectFilter, filter.multiSelectValues, true);
          }
        }
      });
    }
  }

  buildChart(res) {
    this.evaluationLoaded = false;
    var colors = [];
    if (!this.shouldHideBenchmarkDataByResponse(res) || this.shouldHideBenchmarkData()) {
      colors = [
        "#001689", "#40C4FF", "#9744FF", "#BF44B9", "#E57373", "#FFB300"
      ];
    } else {
      colors = [
        "#001689", "url(#benchmark1)", "#40C4FF", "url(#benchmark2)", "#9744FF", "url(#benchmark3)", "#BF44B9", "url(#benchmark4)", "#E57373", "url(#benchmark5)", "#FFB300", "url(#benchmark6)"
      ];
    }

    res = this.adjustResponseForEnvironment(res);
    res = this.filterBenchmarkDataIfWardIsSelected(res);

    let chart: PhBhpBarChartComponent;
    this.results = [];
    const categoryTitle: string = 'DASHBOARD.TOTAL_PERCENT_COMPLIANCE';
    res.forEach(result => {
      if (result.asepticProceduresList.length > 0) {
        let id = result.filterType || 'single';
        if (this.results.findIndex(r => r.id === id) === -1) {
          this.results.push({
            id,
            fiveMomentsList: [],
            gridData: [],
            fields: [...PhBhpObserveStatisticsBeforeAsepticProceduresComponent.INITIAL_FIELDS],
            benchmarkFields: [...PhBhpObserveStatisticsBeforeAsepticProceduresComponent.INITIAL_FIELDS],
            noDataFound: true
          });
        }
      }
    });

    this.compliance.resultsLoader.next(Object.assign([], this.results));
    setTimeout(() => {
      let filterCount: number = 0;
      let benchmarkCount: number = 0;
      let filterTableCount: number = 0;
      let benchmarkTableCount: number = 0;
      res.forEach((asepticProceduresArray: any, index) => {
        let chartId = asepticProceduresArray.filterType || 'single';
        asepticProceduresArray.filterType = chartId;
        let chartIndex = this.results.findIndex(r => r.id === chartId);
        chart = this.charts.get(chartIndex);
        let data = JSON.parse(JSON.stringify(chart.chartOptions));

        if (!data.setId) {
          data.nextIndex = 0;
          data.categoryAxis.categories = [];
          data.categoryAxis.categoryOffset = [];
          data.series = [];
          data.seriesIdentifier = [];
        }

        data.series[data.nextIndex] = { data: [], name: [], dataOffset: [], serieIndex: index };
        data.series[data.nextIndex].color = colors[index];
        data.seriesIdentifier[data.nextIndex] = [];
        chart.chartId = chartId;

        if (asepticProceduresArray.isBenchmark === false) {
          if (asepticProceduresArray.asepticProceduresList.length === 1 && asepticProceduresArray.asepticProceduresList[0].list.length === 0 && chart.noDataFound) {
            this.noDataFound = true;
            chart.noDataFound = true;
          } else {
            this.results[chartIndex].noDataFound = false;
            this.noDataFound = false;
            chart.noDataFound = false;
          }
        } else {
          if (asepticProceduresArray.asepticProceduresList.length === 2 && asepticProceduresArray.asepticProceduresList[0].list.length === 0 && chart.noDataFound) {
            this.noDataFound = true;
            chart.noDataFound = true;
          } else {
            this.results[chartIndex].noDataFound = false;
            this.noDataFound = false;
            chart.noDataFound = false;
          }
        }

        asepticProceduresArray.asepticProceduresList.forEach((asepticProcedures) => {
          let asepticProceduresItem = asepticProcedures;
          data.series[data.nextIndex].dataSetId = asepticProceduresItem.id;
          asepticProceduresItem.list.forEach((item) => {
            this.asepticProcedures.forEach((procedure) => {
              if (procedure.checked) {
                let title = this.layoutService.translateText(procedure.value);
                if (asepticProceduresItem.id >= 0 && asepticProceduresItem.name) {
                  title += " - " + this.layoutService.translateText(asepticProceduresItem.name);
                }

                if (!data.categoryAxis.categories.includes(title)) {
                  data.categoryAxis.categories.push(title);
                  data.categoryAxis.categoryOffset.push({ id: title, setId: asepticProcedures.id });
                }

                switch (procedure.id) {
                  case 1:
                    let ventilationCompliance = item.ventilationCompliance >= 0 ? item.ventilationCompliance : "NODATA";
                    data.series[data.nextIndex].data.push(ventilationCompliance);
                    data.series[data.nextIndex].dataOffset.push({ id: title, setId: asepticProceduresItem.id, value: ventilationCompliance });
                    data.seriesIdentifier[data.nextIndex].push({ id: title, setId: asepticProceduresItem.id });
                    break;
                  case 2:
                    let preparationCompliance = item.preparationCompliance >= 0 ? item.preparationCompliance : "NODATA";
                    data.series[data.nextIndex].data.push(preparationCompliance);
                    data.series[data.nextIndex].dataOffset.push({ id: title, setId: asepticProceduresItem.id, value: preparationCompliance });
                    data.seriesIdentifier[data.nextIndex].push({ id: title, setId: asepticProceduresItem.id });
                    break;
                  case 3:
                    let manipulationCompliance = item.manipulationCompliance >= 0 ? item.manipulationCompliance : "NODATA"
                    data.series[data.nextIndex].data.push(manipulationCompliance);
                    data.series[data.nextIndex].dataOffset.push({ id: title, setId: asepticProceduresItem.id, value: manipulationCompliance });
                    data.seriesIdentifier[data.nextIndex].push({ id: title, setId: asepticProceduresItem.id });
                    break;
                  case 4:
                    let dressingCompliance = item.dressingCompliance >= 0 ? item.dressingCompliance : "NODATA"
                    data.series[data.nextIndex].data.push(dressingCompliance);
                    data.series[data.nextIndex].dataOffset.push({ id: title, setId: asepticProceduresItem.id, value: dressingCompliance });
                    data.seriesIdentifier[data.nextIndex].push({ id: title, setId: asepticProceduresItem.id });
                    break;
                  case 5:
                    let puncturesCompliance = item.puncturesCompliance >= 0 ? item.puncturesCompliance : "NODATA"
                    data.series[data.nextIndex].data.push(puncturesCompliance);
                    data.series[data.nextIndex].dataOffset.push({ id: title, setId: asepticProceduresItem.id, value: puncturesCompliance });
                    data.seriesIdentifier[data.nextIndex].push({ id: title, setId: asepticProceduresItem.id });
                    break;
                  case 6:
                    let contactCompliance = item.contactCompliance >= 0 ? item.contactCompliance : "NODATA"
                    data.series[data.nextIndex].data.push(contactCompliance);
                    data.series[data.nextIndex].dataOffset.push({ id: title, setId: asepticProceduresItem.id, value: contactCompliance });
                    data.seriesIdentifier[data.nextIndex].push({ id: title, setId: asepticProceduresItem.id });
                    break;
                  case 7:
                    let notSpecifiedCompliance = item.notSpecifiedCompliance >= 0 ? item.notSpecifiedCompliance : "NODATA"
                    data.series[data.nextIndex].data.push(notSpecifiedCompliance);
                    data.series[data.nextIndex].dataOffset.push({ id: title, setId: asepticProceduresItem.id, value: notSpecifiedCompliance });
                    data.seriesIdentifier[data.nextIndex].push({ id: title, setId: asepticProceduresItem.id });
                    break;
                }
              }
            });
          });
        });

        let maxLength = data.categoryAxis.categoryOffset.length
        const combinedData = data.series.map(() => new Array(maxLength).fill(null));

        data.series.forEach((item, serieIndex) => {
          item.dataOffset.forEach((value, index) => {
            let indexOffset = data.categoryAxis.categoryOffset.findIndex(offset => offset.id === value.id && offset.setId === value.setId);
            combinedData[serieIndex][indexOffset] = value.value;
          });
        });

        for (let i = 0; i < combinedData.length; i++) {
          data.series[i].data = combinedData[i];
        }

        if (asepticProceduresArray.isBenchmark) {
          if (this.shouldHideBenchmarkData()) {
            return;
          }
          benchmarkCount++;
          const benchmarkName = `${this.data.filter && this.data.filter[benchmarkCount-1] ? this.layoutService.translateText("EVALUATION.BENCHMARK") + ': ' + this.data.filter[benchmarkCount-1].filterName : this.layoutService.translateText("EVALUATION.BENCHMARK") + ': ' +this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (benchmarkCount)}`
          data.series[data.nextIndex].name = [benchmarkName];
          data.series[data.nextIndex].filterName = [benchmarkName];
          data.series[data.nextIndex].filterNum = benchmarkCount;
        } else {
          filterCount++;
          data.series[data.nextIndex].name = [`${this.data.filter && this.data.filter[filterCount - 1] ? this.data.filter[filterCount - 1].filterName : this.layoutService.translate.instant('EVALUATION.FILTER') + ' ' + (filterCount)}`];
          data.series[data.nextIndex].filterName = [`${this.data.filter && this.data.filter[filterCount - 1] ? this.data.filter[filterCount - 1].filterName : this.layoutService.translate.instant('EVALUATION.FILTER') + ' ' + (filterCount)}`];
          data.series[data.nextIndex].filterNum = filterCount
        }

        data.categoryAxis.rotation = 0;
        data.categoryAxis.maxDivisions = 12;
        data.setId = chartId;
        data.nextIndex++;
        chart.chartOptions = data;
        chart.chartDatamani();

        let gridData: any[] = this.results[chartIndex].gridData;
        let fields = this.results[chartIndex].fields;
        let benchmarkFields = this.results[chartIndex].benchmarkFields;
        gridData = Object.assign([], gridData);
        if (asepticProceduresArray && !asepticProceduresArray.isBenchmark) {
          asepticProceduresArray.asepticProceduresList.forEach((element) => {
            let res2 = element.list;
            let multiName = '';
            let elementId = '';
            if (asepticProceduresArray.filterType && asepticProceduresArray.filterType != 'single') {

              multiName = element.name;
              elementId = element.id;
              if (element.list.length == 0 && element.noData == true) {
                multiName = 'EVALUATION.NO_DATA'
                elementId = 'nodata';
              }

              const filterName = `${this.data.filter && this.data.filter[filterTableCount] ? this.data.filter[filterTableCount].filterName : this.layoutService.translate.instant('EVALUATION.FILTER') + ' ' + (filterTableCount + 1)}`;
              fields.push(
                { 'field': `column_filter_${filterTableCount + 1}_${elementId}_compliance`, 'title': 'DASHBOARD.COMPLIANCE', 'group': filterName, multiName: multiName },
                { 'field': `column_filter_${filterTableCount + 1}_${elementId}_opportunities`, 'title': 'DASHBOARD.OPPORTUNITIES', 'group': filterName, multiName: multiName },
                { 'field': `column_filter_${filterTableCount + 1}_${elementId}_positive`, 'title': 'EVALUATION.POSITIVE_ACTIONS', 'group': filterName, multiName: multiName },
              );

              res2.forEach((item, i) => {
                if (gridData.length == 0) {
                  var ventilation = { name: this.layoutService.translateText(this.asepticProcedures[0].value) }
                  var preparation = { name: this.layoutService.translateText(this.asepticProcedures[1].value) }
                  var manipulation = { name: this.layoutService.translateText(this.asepticProcedures[2].value) }
                  var dressing = { name: this.layoutService.translateText(this.asepticProcedures[3].value) }
                  var punctures = { name: this.layoutService.translateText(this.asepticProcedures[4].value) }
                  var contacts = { name: this.layoutService.translateText(this.asepticProcedures[5].value) }
                  var notSpecified = { name: this.layoutService.translateText(this.asepticProcedures[6].value) }

                  ventilation[`column_filter_${filterTableCount + 1}_${elementId}_compliance`] = item.ventilationCompliance == -1 ? "N/A" : item.ventilationCompliance;
                  ventilation[`column_filter_${filterTableCount + 1}_${elementId}_opportunities`] = item.ventilationOpportunities;
                  ventilation[`column_filter_${filterTableCount + 1}_${elementId}_positive`] = item.ventilationPositives;

                  preparation[`column_filter_${filterTableCount + 1}_${elementId}_compliance`] = item.preparationCompliance == -1 ? "N/A" : item.preparationCompliance;
                  preparation[`column_filter_${filterTableCount + 1}_${elementId}_opportunities`] = item.preparationOpportunities;
                  preparation[`column_filter_${filterTableCount + 1}_${elementId}_positive`] = item.preparationPositives;

                  manipulation[`column_filter_${filterTableCount + 1}_${elementId}_compliance`] = item.manipulationCompliance == -1 ? "N/A" : item.manipulationCompliance;
                  manipulation[`column_filter_${filterTableCount + 1}_${elementId}_opportunities`] = item.manipulationOpportunities;
                  manipulation[`column_filter_${filterTableCount + 1}_${elementId}_positive`] = item.manipulationPositives;

                  dressing[`column_filter_${filterTableCount + 1}_${elementId}_compliance`] = item.dressingCompliance == -1 ? "N/A" : item.dressingCompliance;
                  dressing[`column_filter_${filterTableCount + 1}_${elementId}_opportunities`] = item.dressingOpportunities;
                  dressing[`column_filter_${filterTableCount + 1}_${elementId}_positive`] = item.dressingPositives;

                  punctures[`column_filter_${filterTableCount + 1}_${elementId}_compliance`] = item.puncturesCompliance == -1 ? "N/A" : item.puncturesCompliance;
                  punctures[`column_filter_${filterTableCount + 1}_${elementId}_opportunities`] = item.puncturesOpportunities;
                  punctures[`column_filter_${filterTableCount + 1}_${elementId}_positive`] = item.puncturesPositives;

                  contacts[`column_filter_${filterTableCount + 1}_${elementId}_compliance`] = item.contactCompliance == -1 ? "N/A" : item.contactCompliance;
                  contacts[`column_filter_${filterTableCount + 1}_${elementId}_opportunities`] = item.contactOpportunities;
                  contacts[`column_filter_${filterTableCount + 1}_${elementId}_positive`] = item.contactPositives;

                  notSpecified[`column_filter_${filterTableCount + 1}_${elementId}_compliance`] = item.notSpecifiedCompliance == -1 ? "N/A" : item.notSpecifiedCompliance;
                  notSpecified[`column_filter_${filterTableCount + 1}_${elementId}_opportunities`] = item.notSpecifiedOpportunities;
                  notSpecified[`column_filter_${filterTableCount + 1}_${elementId}_positive`] = item.notSpecifiedPositives;

                  gridData.push(ventilation, preparation, manipulation, dressing, punctures, contacts, notSpecified);
                } else {
                  this.asepticProcedures.forEach(asepticProcedure => {
                    if (asepticProcedure.checked) {
                      switch (asepticProcedure.id) {
                        case 1:
                          let ventilationIndex = gridData.findIndex(item => item.name == this.layoutService.translateText(this.asepticProcedures[0].value));
                          if (ventilationIndex != -1) {
                            gridData[ventilationIndex][`column_filter_${filterTableCount + 1}_${elementId}_compliance`] = item.ventilationCompliance == -1 ? "N/A" : item.ventilationCompliance;
                            gridData[ventilationIndex][`column_filter_${filterTableCount + 1}_${elementId}_opportunities`] = item.ventilationOpportunities;
                            gridData[ventilationIndex][`column_filter_${filterTableCount + 1}_${elementId}_positive`] = item.ventilationPositives;
                          } else {
                            var ventilation = { name: this.layoutService.translateText(this.asepticProcedures[0].value) }
                            ventilation[`column_filter_${filterTableCount + 1}_${elementId}_compliance`] = item.ventilationCompliance == -1 ? "N/A" : item.ventilationCompliance;
                            ventilation[`column_filter_${filterTableCount + 1}_${elementId}_opportunities`] = item.ventilationOpportunities;
                            ventilation[`column_filter_${filterTableCount + 1}_${elementId}_positive`] = item.ventilationPositives;

                            gridData.unshift(ventilation);
                          }
                          break;
                        case 2:
                          let preparationIndex = gridData.findIndex(item => item.name == this.layoutService.translateText(this.asepticProcedures[1].value));
                          if (preparationIndex != -1) {
                            gridData[preparationIndex][`column_filter_${filterTableCount + 1}_${elementId}_compliance`] = item.preparationCompliance == -1 ? "N/A" : item.preparationCompliance;
                            gridData[preparationIndex][`column_filter_${filterTableCount + 1}_${elementId}_opportunities`] = item.preparationOpportunities;
                            gridData[preparationIndex][`column_filter_${filterTableCount + 1}_${elementId}_positive`] = item.preparationPositives;
                          } else {
                            var preparation = { name: this.layoutService.translateText(this.asepticProcedures[1].value) }
                            preparation[`column_filter_${filterTableCount + 1}_${elementId}_compliance`] = item.preparationCompliance == -1 ? "N/A" : item.preparationCompliance;
                            preparation[`column_filter_${filterTableCount + 1}_${elementId}_opportunities`] = item.preparationOpportunities;
                            preparation[`column_filter_${filterTableCount + 1}_${elementId}_positive`] = item.preparationPositives;

                            gridData.splice(1, 0, preparation);
                          }
                          break;
                        case 3:
                          var manipulationIndex = gridData.findIndex(item => item.name == this.layoutService.translateText(this.asepticProcedures[2].value));
                          if (manipulationIndex != -1) {
                            gridData[manipulationIndex][`column_filter_${filterTableCount + 1}_${elementId}_compliance`] = item.manipulationCompliance == -1 ? "N/A" : item.manipulationCompliance;
                            gridData[manipulationIndex][`column_filter_${filterTableCount + 1}_${elementId}_opportunities`] = item.manipulationOpportunities;
                            gridData[manipulationIndex][`column_filter_${filterTableCount + 1}_${elementId}_positive`] = item.manipulationPositives;
                          } else {
                            var manipulation = { name: this.layoutService.translateText(this.asepticProcedures[2].value) }
                            manipulation[`column_filter_${filterTableCount + 1}_${elementId}_compliance`] = item.manipulationCompliance == -1 ? "N/A" : item.manipulationCompliance;
                            manipulation[`column_filter_${filterTableCount + 1}_${elementId}_opportunities`] = item.manipulationOpportunities;
                            manipulation[`column_filter_${filterTableCount + 1}_${elementId}_positive`] = item.manipulationPositives;

                            gridData.splice(2, 0, manipulation);
                          }
                          break;
                        case 4:
                          var dressingIndex = gridData.findIndex(item => item.name == this.layoutService.translateText(this.asepticProcedures[3].value));
                          if (dressingIndex != -1) {
                            gridData[dressingIndex][`column_filter_${filterTableCount + 1}_${elementId}_compliance`] = item.dressingCompliance == -1 ? "N/A" : item.dressingCompliance;
                            gridData[dressingIndex][`column_filter_${filterTableCount + 1}_${elementId}_opportunities`] = item.dressingOpportunities;
                            gridData[dressingIndex][`column_filter_${filterTableCount + 1}_${elementId}_positive`] = item.dressingPositives;
                          } else {
                            var dressing = { name: this.layoutService.translateText(this.asepticProcedures[3].value) }
                            dressing[`column_filter_${filterTableCount + 1}_${elementId}_compliance`] = item.dressingCompliance == -1 ? "N/A" : item.dressingCompliance;
                            dressing[`column_filter_${filterTableCount + 1}_${elementId}_opportunities`] = item.dressingOpportunities;
                            dressing[`column_filter_${filterTableCount + 1}_${elementId}_positive`] = item.dressingPositives;

                            gridData.splice(3, 0, dressing);
                          }
                          break;
                        case 5:
                          var punctureIndex = gridData.findIndex(item => item.name == this.layoutService.translateText(this.asepticProcedures[4].value));
                          if (punctureIndex != -1) {
                            gridData[punctureIndex][`column_filter_${filterTableCount + 1}_${elementId}_compliance`] = item.puncturesCompliance == -1 ? "N/A" : item.puncturesCompliance;
                            gridData[punctureIndex][`column_filter_${filterTableCount + 1}_${elementId}_opportunities`] = item.puncturesOpportunities;
                            gridData[punctureIndex][`column_filter_${filterTableCount + 1}_${elementId}_positive`] = item.puncturesPositives;
                          } else {
                            var punctures = { name: this.layoutService.translateText(this.asepticProcedures[4].value) }
                            punctures[`column_filter_${filterTableCount + 1}_${elementId}_compliance`] = item.puncturesCompliance == -1 ? "N/A" : item.puncturesCompliance;
                            punctures[`column_filter_${filterTableCount + 1}_${elementId}_opportunities`] = item.puncturesOpportunities;
                            punctures[`column_filter_${filterTableCount + 1}_${elementId}_positive`] = item.puncturesPositives;

                            gridData.splice(4, 0, punctures);
                          }
                          break;
                        case 6:
                          var contactIndex = gridData.findIndex(item => item.name == this.layoutService.translateText(this.asepticProcedures[5].value));
                          if (contactIndex != -1) {
                            gridData[contactIndex][`column_filter_${filterTableCount + 1}_${elementId}_compliance`] = item.contactCompliance == -1 ? "N/A" : item.contactCompliance;
                            gridData[contactIndex][`column_filter_${filterTableCount + 1}_${elementId}_opportunities`] = item.contactOpportunities || 0;
                            gridData[contactIndex][`column_filter_${filterTableCount + 1}_${elementId}_positive`] = item.contactPositives || 0;
                          } else {
                            var contacts = { name: this.layoutService.translateText(this.asepticProcedures[5].value) }
                            contacts[`column_filter_${filterTableCount + 1}_${elementId}_compliance`] = item.contactCompliance == -1 ? "N/A" : item.contactCompliance;
                            contacts[`column_filter_${filterTableCount + 1}_${elementId}_opportunities`] = item.contactOpportunities || 0;
                            contacts[`column_filter_${filterTableCount + 1}_${elementId}_positive`] = item.contactPositives || 0;

                            gridData.splice(5, 0, contacts);
                          }
                          break;
                        case 7:
                          var notSpecifiedIndex = gridData.findIndex(item => item.name == this.layoutService.translateText(this.asepticProcedures[6].value));
                          if (notSpecifiedIndex != -1) {
                            gridData[notSpecifiedIndex][`column_filter_${filterTableCount + 1}_${elementId}_compliance`] = item.notSpecifiedCompliance == -1 ? "N/A" : item.notSpecifiedCompliance;
                            gridData[notSpecifiedIndex][`column_filter_${filterTableCount + 1}_${elementId}_opportunities`] = item.notSpecifiedOpportunities || 0;
                            gridData[notSpecifiedIndex][`column_filter_${filterTableCount + 1}_${elementId}_positive`] = item.notSpecifiedPositives || 0;
                          } else {
                            var notSpecified = { name: this.layoutService.translateText(this.asepticProcedures[6].value) }
                            notSpecified[`column_filter_${filterTableCount + 1}_${elementId}_compliance`] = item.notSpecifiedCompliance == -1 ? "N/A" : item.notSpecifiedCompliance;
                            notSpecified[`column_filter_${filterTableCount + 1}_${elementId}_opportunities`] = item.notSpecifiedOpportunities || 0;
                            notSpecified[`column_filter_${filterTableCount + 1}_${elementId}_positive`] = item.notSpecifiedPositives || 0;

                            gridData.push(notSpecified);
                          }
                          break;
                      }
                    }
                  });
                }
              });
            } else {

              const filterName = `${this.data.filter && this.data.filter[filterTableCount] ? this.data.filter[filterTableCount].filterName : this.layoutService.translate.instant('EVALUATION.FILTER') + ' ' + (filterTableCount + 1)}`;
              fields.push(
                { 'field': `column_filter_${filterTableCount + 1}_compliance`, 'title': 'DASHBOARD.COMPLIANCE', 'group': filterName },
                { 'field': `column_filter_${filterTableCount + 1}_opportunities`, 'title': 'DASHBOARD.OPPORTUNITIES', 'group': filterName },
                { 'field': `column_filter_${filterTableCount + 1}_positive`, 'title': 'EVALUATION.POSITIVE_ACTIONS', 'group': filterName },
              );

              res2.forEach((item, i) => {
                if (gridData.length == 0) {
                  var ventilation = { name: this.layoutService.translateText(this.asepticProcedures[0].value) }
                  var preparation = { name: this.layoutService.translateText(this.asepticProcedures[1].value) }
                  var manipulation = { name: this.layoutService.translateText(this.asepticProcedures[2].value) }
                  var dressing = { name: this.layoutService.translateText(this.asepticProcedures[3].value) }
                  var punctures = { name: this.layoutService.translateText(this.asepticProcedures[4].value) }
                  var contacts = { name: this.layoutService.translateText(this.asepticProcedures[5].value) }
                  var notSpecified = { name: this.layoutService.translateText(this.asepticProcedures[6].value) }

                  ventilation[`column_filter_${filterTableCount + 1}_compliance`] = item.ventilationCompliance == -1 ? "N/A" : item.ventilationCompliance;
                  ventilation[`column_filter_${filterTableCount + 1}_opportunities`] = item.ventilationOpportunities;
                  ventilation[`column_filter_${filterTableCount + 1}_positive`] = item.ventilationPositives;

                  preparation[`column_filter_${filterTableCount + 1}_compliance`] = item.preparationCompliance == -1 ? "N/A" : item.preparationCompliance;
                  preparation[`column_filter_${filterTableCount + 1}_opportunities`] = item.preparationOpportunities;
                  preparation[`column_filter_${filterTableCount + 1}_positive`] = item.preparationPositives;

                  manipulation[`column_filter_${filterTableCount + 1}_compliance`] = item.manipulationCompliance == -1 ? "N/A" : item.manipulationCompliance;
                  manipulation[`column_filter_${filterTableCount + 1}_opportunities`] = item.manipulationOpportunities;
                  manipulation[`column_filter_${filterTableCount + 1}_positive`] = item.manipulationPositives;

                  dressing[`column_filter_${filterTableCount + 1}_compliance`] = item.dressingCompliance == -1 ? "N/A" : item.dressingCompliance;
                  dressing[`column_filter_${filterTableCount + 1}_opportunities`] = item.dressingOpportunities;
                  dressing[`column_filter_${filterTableCount + 1}_positive`] = item.dressingPositives;

                  punctures[`column_filter_${filterTableCount + 1}_compliance`] = item.puncturesCompliance == -1 ? "N/A" : item.puncturesCompliance;
                  punctures[`column_filter_${filterTableCount + 1}_opportunities`] = item.puncturesOpportunities;
                  punctures[`column_filter_${filterTableCount + 1}_positive`] = item.puncturesPositives;

                  contacts[`column_filter_${filterTableCount + 1}_compliance`] = item.contactCompliance == -1 ? "N/A" : item.contactCompliance;
                  contacts[`column_filter_${filterTableCount + 1}_opportunities`] = item.contactOpportunities;
                  contacts[`column_filter_${filterTableCount + 1}_positive`] = item.contactPositives;

                  notSpecified[`column_filter_${filterTableCount + 1}_compliance`] = item.notSpecifiedCompliance == -1 ? "N/A" : item.notSpecifiedCompliance;
                  notSpecified[`column_filter_${filterTableCount + 1}_opportunities`] = item.notSpecifiedOpportunities;
                  notSpecified[`column_filter_${filterTableCount + 1}_positive`] = item.notSpecifiedPositives;

                  gridData.push(ventilation, preparation, manipulation, dressing, punctures, contacts, notSpecified);
                } else {
                  this.asepticProcedures.forEach(asepticProcedure => {
                    if (asepticProcedure.checked) {
                      switch (asepticProcedure.id) {
                        case 1:
                          let ventilationIndex = gridData.findIndex(item => item.name == this.layoutService.translateText(this.asepticProcedures[0].value));
                          if (ventilationIndex != -1) {
                            gridData[ventilationIndex][`column_filter_${filterTableCount + 1}_compliance`] = item.ventilationCompliance == -1 ? "N/A" : item.ventilationCompliance;
                            gridData[ventilationIndex][`column_filter_${filterTableCount + 1}_opportunities`] = item.ventilationOpportunities;
                            gridData[ventilationIndex][`column_filter_${filterTableCount + 1}_positive`] = item.ventilationPositives;
                          } else {
                            var ventilation = { name: this.layoutService.translateText(this.asepticProcedures[0].value) }
                            ventilation[`column_filter_${filterTableCount + 1}_compliance`] = item.ventilationCompliance == -1 ? "N/A" : item.ventilationCompliance;
                            ventilation[`column_filter_${filterTableCount + 1}_opportunities`] = item.ventilationOpportunities;
                            ventilation[`column_filter_${filterTableCount + 1}_positive`] = item.ventilationPositives;

                            gridData.unshift(ventilation);
                          }
                          break;
                        case 2:
                          let preparationIndex = gridData.findIndex(item => item.name == this.layoutService.translateText(this.asepticProcedures[1].value));
                          if (preparationIndex != -1) {
                            gridData[preparationIndex][`column_filter_${filterTableCount + 1}_compliance`] = item.preparationCompliance == -1 ? "N/A" : item.preparationCompliance;
                            gridData[preparationIndex][`column_filter_${filterTableCount + 1}_opportunities`] = item.preparationOpportunities;
                            gridData[preparationIndex][`column_filter_${filterTableCount + 1}_positive`] = item.preparationPositives;
                          } else {
                            var preparation = { name: this.layoutService.translateText(this.asepticProcedures[1].value) }
                            preparation[`column_filter_${filterTableCount + 1}_compliance`] = item.preparationCompliance == -1 ? "N/A" : item.preparationCompliance;
                            preparation[`column_filter_${filterTableCount + 1}_opportunities`] = item.preparationOpportunities;
                            preparation[`column_filter_${filterTableCount + 1}_positive`] = item.preparationPositives;

                            gridData.splice(1, 0, preparation);
                          }
                          break;
                        case 3:
                          var manipulationIndex = gridData.findIndex(item => item.name == this.layoutService.translateText(this.asepticProcedures[2].value));
                          if (manipulationIndex != -1) {
                            gridData[manipulationIndex][`column_filter_${filterTableCount + 1}_compliance`] = item.manipulationCompliance == -1 ? "N/A" : item.manipulationCompliance;
                            gridData[manipulationIndex][`column_filter_${filterTableCount + 1}_opportunities`] = item.manipulationOpportunities;
                            gridData[manipulationIndex][`column_filter_${filterTableCount + 1}_positive`] = item.manipulationPositives;
                          } else {
                            var manipulation = { name: this.layoutService.translateText(this.asepticProcedures[2].value) }
                            manipulation[`column_filter_${filterTableCount + 1}_compliance`] = item.manipulationCompliance == -1 ? "N/A" : item.manipulationCompliance;
                            manipulation[`column_filter_${filterTableCount + 1}_opportunities`] = item.manipulationOpportunities;
                            manipulation[`column_filter_${filterTableCount + 1}_positive`] = item.manipulationPositives;

                            gridData.splice(2, 0, manipulation);
                          }
                          break;
                        case 4:
                          var dressingIndex = gridData.findIndex(item => item.name == this.layoutService.translateText(this.asepticProcedures[3].value));
                          if (dressingIndex != -1) {
                            gridData[dressingIndex][`column_filter_${filterTableCount + 1}_compliance`] = item.dressingCompliance == -1 ? "N/A" : item.dressingCompliance;
                            gridData[dressingIndex][`column_filter_${filterTableCount + 1}_opportunities`] = item.dressingOpportunities;
                            gridData[dressingIndex][`column_filter_${filterTableCount + 1}_positive`] = item.dressingPositives;
                          } else {
                            var dressing = { name: this.layoutService.translateText(this.asepticProcedures[3].value) }
                            dressing[`column_filter_${filterTableCount + 1}_compliance`] = item.dressingCompliance == -1 ? "N/A" : item.dressingCompliance;
                            dressing[`column_filter_${filterTableCount + 1}_opportunities`] = item.dressingOpportunities;
                            dressing[`column_filter_${filterTableCount + 1}_positive`] = item.dressingPositives;

                            gridData.splice(3, 0, dressing);
                          }
                          break;
                        case 5:
                          var punctureIndex = gridData.findIndex(item => item.name == this.layoutService.translateText(this.asepticProcedures[4].value));
                          if (punctureIndex != -1) {
                            gridData[punctureIndex][`column_filter_${filterTableCount + 1}_compliance`] = item.puncturesCompliance == -1 ? "N/A" : item.puncturesCompliance;
                            gridData[punctureIndex][`column_filter_${filterTableCount + 1}_opportunities`] = item.puncturesOpportunities;
                            gridData[punctureIndex][`column_filter_${filterTableCount + 1}_positive`] = item.puncturesPositives;
                          } else {
                            var punctures = { name: this.layoutService.translateText(this.asepticProcedures[4].value) }
                            punctures[`column_filter_${filterTableCount + 1}_compliance`] = item.puncturesCompliance == -1 ? "N/A" : item.puncturesCompliance;
                            punctures[`column_filter_${filterTableCount + 1}_opportunities`] = item.puncturesOpportunities;
                            punctures[`column_filter_${filterTableCount + 1}_positive`] = item.puncturesPositives;

                            gridData.splice(4, 0, punctures);
                          }
                          break;
                        case 6:
                          var contactIndex = gridData.findIndex(item => item.name == this.layoutService.translateText(this.asepticProcedures[5].value));
                          if (contactIndex != -1) {
                            gridData[contactIndex][`column_filter_${filterTableCount + 1}_compliance`] = item.contactCompliance == -1 ? "N/A" : item.contactCompliance;
                            gridData[contactIndex][`column_filter_${filterTableCount + 1}_opportunities`] = item.contactOpportunities || 0;
                            gridData[contactIndex][`column_filter_${filterTableCount + 1}_positive`] = item.contactPositives || 0;
                          } else {
                            var contacts = { name: this.layoutService.translateText(this.asepticProcedures[5].value) }
                            contacts[`column_filter_${filterTableCount + 1}_compliance`] = item.contactCompliance == -1 ? "N/A" : item.contactCompliance;
                            contacts[`column_filter_${filterTableCount + 1}_opportunities`] = item.contactOpportunities || 0;
                            contacts[`column_filter_${filterTableCount + 1}_positive`] = item.contactPositives || 0;

                            gridData.splice(5, 0, contacts);
                          }
                          break;
                        case 7:
                          var notSpecifiedIndex = gridData.findIndex(item => item.name == this.layoutService.translateText(this.asepticProcedures[6].value));
                          if (notSpecifiedIndex != -1) {
                            gridData[notSpecifiedIndex][`column_filter_${filterTableCount + 1}_compliance`] = item.notSpecifiedCompliance == -1 ? "N/A" : item.notSpecifiedCompliance;
                            gridData[notSpecifiedIndex][`column_filter_${filterTableCount + 1}_opportunities`] = item.notSpecifiedOpportunities || 0;
                            gridData[notSpecifiedIndex][`column_filter_${filterTableCount + 1}_positive`] = item.notSpecifiedPositives || 0;
                          } else {
                            var notSpecified = { name: this.layoutService.translateText(this.asepticProcedures[6].value) }
                            notSpecified[`column_filter_${filterTableCount + 1}_compliance`] = item.notSpecifiedCompliance == -1 ? "N/A" : item.notSpecifiedCompliance;
                            notSpecified[`column_filter_${filterTableCount + 1}_opportunities`] = item.notSpecifiedOpportunities || 0;
                            notSpecified[`column_filter_${filterTableCount + 1}_positive`] = item.notSpecifiedPositives || 0;

                            gridData.push(notSpecified);
                          }
                          break;
                      }
                    }
                  });
                }
              });
            }
          });
        } else {
          asepticProceduresArray.asepticProceduresList.forEach((element) => {
            let res2 = element.list;
            let multiName = '';
            let elementId = '';
            if (asepticProceduresArray.filterType && asepticProceduresArray.filterType != 'single') {

              multiName = element.name;
              elementId = element.id;
              if (element.list.length == 0 && element.noData == true) {
                multiName = 'EVALUATION.NO_DATA'
                elementId = 'nodata';
              }

              const benchmarkName = `${this.data.filter && this.data.filter[benchmarkTableCount] ? this.layoutService.translateText("EVALUATION.BENCHMARK") + ': ' + this.data.filter[benchmarkTableCount].filterName : this.layoutService.translateText("EVALUATION.BENCHMARK") + ': ' +this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (benchmarkTableCount + 1)}`

              benchmarkFields.push(
                { 'field': `column_benchmark_${benchmarkTableCount + 1}_${elementId}_compliance`, 'title': 'DASHBOARD.COMPLIANCE', 'group': benchmarkName, multiName: multiName },
                { 'field': `column_benchmark_${benchmarkTableCount + 1}_${elementId}_opportunities`, 'title': 'DASHBOARD.OPPORTUNITIES', 'group': benchmarkName, multiName: multiName },
                { 'field': `column_benchmark_${benchmarkTableCount + 1}_${elementId}_positive`, 'title': 'EVALUATION.POSITIVE_ACTIONS', 'group': benchmarkName, multiName: multiName },
              );

              res2.forEach((item, i) => {
                if (gridData.length == 0) {
                  var ventilation = { name: this.layoutService.translateText(this.asepticProcedures[0].value) }
                  var preparation = { name: this.layoutService.translateText(this.asepticProcedures[1].value) }
                  var manipulation = { name: this.layoutService.translateText(this.asepticProcedures[2].value) }
                  var dressing = { name: this.layoutService.translateText(this.asepticProcedures[3].value) }
                  var punctures = { name: this.layoutService.translateText(this.asepticProcedures[4].value) }
                  var contacts = { name: this.layoutService.translateText(this.asepticProcedures[5].value) }
                  var notSpecified = { name: this.layoutService.translateText(this.asepticProcedures[6].value) }

                  ventilation[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_compliance`] = item.ventilationCompliance == -1 ? "N/A" : item.ventilationCompliance;
                  ventilation[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_opportunities`] = item.ventilationOpportunities;
                  ventilation[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_positive`] = item.ventilationPositives;

                  preparation[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_compliance`] = item.preparationCompliance == -1 ? "N/A" : item.preparationCompliance;
                  preparation[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_opportunities`] = item.preparationOpportunities;
                  preparation[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_positive`] = item.preparationPositives;

                  manipulation[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_compliance`] = item.manipulationCompliance == -1 ? "N/A" : item.manipulationCompliance;
                  manipulation[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_opportunities`] = item.manipulationOpportunities;
                  manipulation[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_positive`] = item.manipulationPositives;

                  dressing[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_compliance`] = item.dressingCompliance == -1 ? "N/A" : item.dressingCompliance;
                  dressing[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_opportunities`] = item.dressingOpportunities;
                  dressing[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_positive`] = item.dressingPositives;

                  punctures[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_compliance`] = item.puncturesCompliance == -1 ? "N/A" : item.puncturesCompliance;
                  punctures[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_opportunities`] = item.puncturesOpportunities;
                  punctures[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_positive`] = item.puncturesPositives;

                  contacts[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_compliance`] = item.contactCompliance == -1 ? "N/A" : item.contactCompliance;
                  contacts[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_opportunities`] = item.contactOpportunities;
                  contacts[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_positive`] = item.contactPositives;

                  notSpecified[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_compliance`] = item.notSpecifiedCompliance == -1 ? "N/A" : item.notSpecifiedCompliance;
                  notSpecified[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_opportunities`] = item.notSpecifiedOpportunities;
                  notSpecified[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_positive`] = item.notSpecifiedPositives;

                  gridData.push(ventilation, preparation, manipulation, dressing, punctures, contacts, notSpecified);
                } else {
                  this.asepticProcedures.forEach(asepticProcedure => {
                    if (asepticProcedure.checked) {
                      switch (asepticProcedure.id) {
                        case 1:
                          let ventilationIndex = gridData.findIndex(item => item.name == this.layoutService.translateText(this.asepticProcedures[0].value));
                          if (ventilationIndex != -1) {
                            gridData[ventilationIndex][`column_benchmark_${benchmarkTableCount + 1}_${elementId}_compliance`] = item.ventilationCompliance == -1 ? "N/A" : item.ventilationCompliance;
                            gridData[ventilationIndex][`column_benchmark_${benchmarkTableCount + 1}_${elementId}_opportunities`] = item.ventilationOpportunities;
                            gridData[ventilationIndex][`column_benchmark_${benchmarkTableCount + 1}_${elementId}_positive`] = item.ventilationPositives;
                          } else {
                            var ventilation = { name: this.layoutService.translateText(this.asepticProcedures[0].value) }
                            ventilation[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_compliance`] = item.ventilationCompliance == -1 ? "N/A" : item.ventilationCompliance;
                            ventilation[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_opportunities`] = item.ventilationOpportunities;
                            ventilation[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_positive`] = item.ventilationPositives;

                            gridData.unshift(ventilation);
                          }
                          break;
                        case 2:
                          let preparationIndex = gridData.findIndex(item => item.name == this.layoutService.translateText(this.asepticProcedures[1].value));
                          if (preparationIndex != -1) {
                            gridData[preparationIndex][`column_benchmark_${benchmarkTableCount + 1}_${elementId}_compliance`] = item.preparationCompliance == -1 ? "N/A" : item.preparationCompliance;
                            gridData[preparationIndex][`column_benchmark_${benchmarkTableCount + 1}_${elementId}_opportunities`] = item.preparationOpportunities;
                            gridData[preparationIndex][`column_benchmark_${benchmarkTableCount + 1}_${elementId}_positive`] = item.preparationPositives;
                          } else {
                            var preparation = { name: this.layoutService.translateText(this.asepticProcedures[1].value) }
                            preparation[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_compliance`] = item.preparationCompliance == -1 ? "N/A" : item.preparationCompliance;
                            preparation[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_opportunities`] = item.preparationOpportunities;
                            preparation[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_positive`] = item.preparationPositives;

                            gridData.splice(1, 0, preparation);
                          }
                          break;
                        case 3:
                          var manipulationIndex = gridData.findIndex(item => item.name == this.layoutService.translateText(this.asepticProcedures[2].value));
                          if (manipulationIndex != -1) {
                            gridData[manipulationIndex][`column_benchmark_${benchmarkTableCount + 1}_${elementId}_compliance`] = item.manipulationCompliance == -1 ? "N/A" : item.manipulationCompliance;
                            gridData[manipulationIndex][`column_benchmark_${benchmarkTableCount + 1}_${elementId}_opportunities`] = item.manipulationOpportunities;
                            gridData[manipulationIndex][`column_benchmark_${benchmarkTableCount + 1}_${elementId}_positive`] = item.manipulationPositives;
                          } else {
                            var manipulation = { name: this.layoutService.translateText(this.asepticProcedures[2].value) }
                            manipulation[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_compliance`] = item.manipulationCompliance == -1 ? "N/A" : item.manipulationCompliance;
                            manipulation[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_opportunities`] = item.manipulationOpportunities;
                            manipulation[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_positive`] = item.manipulationPositives;

                            gridData.splice(2, 0, manipulation);
                          }
                          break;
                        case 4:
                          var dressingIndex = gridData.findIndex(item => item.name == this.layoutService.translateText(this.asepticProcedures[3].value));
                          if (dressingIndex != -1) {
                            gridData[dressingIndex][`column_benchmark_${benchmarkTableCount + 1}_${elementId}_compliance`] = item.dressingCompliance == -1 ? "N/A" : item.dressingCompliance;
                            gridData[dressingIndex][`column_benchmark_${benchmarkTableCount + 1}_${elementId}_opportunities`] = item.dressingOpportunities;
                            gridData[dressingIndex][`column_benchmark_${benchmarkTableCount + 1}_${elementId}_positive`] = item.dressingPositives;
                          } else {
                            var dressing = { name: this.layoutService.translateText(this.asepticProcedures[3].value) }
                            dressing[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_compliance`] = item.dressingCompliance == -1 ? "N/A" : item.dressingCompliance;
                            dressing[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_opportunities`] = item.dressingOpportunities;
                            dressing[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_positive`] = item.dressingPositives;

                            gridData.splice(3, 0, dressing);
                          }
                          break;
                        case 5:
                          var punctureIndex = gridData.findIndex(item => item.name == this.layoutService.translateText(this.asepticProcedures[4].value));
                          if (punctureIndex != -1) {
                            gridData[punctureIndex][`column_benchmark_${benchmarkTableCount + 1}_${elementId}_compliance`] = item.puncturesCompliance == -1 ? "N/A" : item.puncturesCompliance;
                            gridData[punctureIndex][`column_benchmark_${benchmarkTableCount + 1}_${elementId}_opportunities`] = item.puncturesOpportunities;
                            gridData[punctureIndex][`column_benchmark_${benchmarkTableCount + 1}_${elementId}_positive`] = item.puncturesPositives;
                          } else {
                            var punctures = { name: this.layoutService.translateText(this.asepticProcedures[4].value) }
                            punctures[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_compliance`] = item.puncturesCompliance == -1 ? "N/A" : item.puncturesCompliance;
                            punctures[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_opportunities`] = item.puncturesOpportunities;
                            punctures[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_positive`] = item.puncturesPositives;

                            gridData.splice(4, 0, punctures);
                          }
                          break;
                        case 6:
                          var contactIndex = gridData.findIndex(item => item.name == this.layoutService.translateText(this.asepticProcedures[5].value));
                          if (contactIndex != -1) {
                            gridData[contactIndex][`column_benchmark_${benchmarkTableCount + 1}_${elementId}_compliance`] = item.contactCompliance == -1 ? "N/A" : item.contactCompliance;
                            gridData[contactIndex][`column_benchmark_${benchmarkTableCount + 1}_${elementId}_opportunities`] = item.contactOpportunities || 0;
                            gridData[contactIndex][`column_benchmark_${benchmarkTableCount + 1}_${elementId}_positive`] = item.contactPositives || 0;
                          } else {
                            var contacts = { name: this.layoutService.translateText(this.asepticProcedures[5].value) }
                            contacts[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_compliance`] = item.contactCompliance == -1 ? "N/A" : item.contactCompliance;
                            contacts[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_opportunities`] = item.contactOpportunities || 0;
                            contacts[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_positive`] = item.contactPositives || 0;

                            gridData.splice(5, 0, contacts);
                          }
                          break;
                        case 7:
                          var notSpecifiedIndex = gridData.findIndex(item => item.name == this.layoutService.translateText(this.asepticProcedures[6].value));
                          if (notSpecifiedIndex != -1) {
                            gridData[notSpecifiedIndex][`column_benchmark_${benchmarkTableCount + 1}_${elementId}_compliance`] = item.notSpecifiedCompliance == -1 ? "N/A" : item.notSpecifiedCompliance;
                            gridData[notSpecifiedIndex][`column_benchmark_${benchmarkTableCount + 1}_${elementId}_opportunities`] = item.notSpecifiedOpportunities || 0;
                            gridData[notSpecifiedIndex][`column_benchmark_${benchmarkTableCount + 1}_${elementId}_positive`] = item.notSpecifiedPositives || 0;
                          } else {
                            var notSpecified = { name: this.layoutService.translateText(this.asepticProcedures[6].value) }
                            notSpecified[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_compliance`] = item.notSpecifiedCompliance == -1 ? "N/A" : item.notSpecifiedCompliance;
                            notSpecified[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_opportunities`] = item.notSpecifiedOpportunities || 0;
                            notSpecified[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_positive`] = item.notSpecifiedPositives || 0;

                            gridData.push(notSpecified);
                          }
                          break;
                      }
                    }
                  });
                }
              });
            } else {

              const benchmarkName = `${this.data.filter && this.data.filter[benchmarkTableCount] ? this.layoutService.translateText("EVALUATION.BENCHMARK") + ': ' + this.data.filter[benchmarkTableCount].filterName : this.layoutService.translateText("EVALUATION.BENCHMARK") + ': ' +this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (benchmarkTableCount + 1)}`

              benchmarkFields.push(
                { 'field': `column_benchmark_${benchmarkTableCount + 1}_compliance`, 'title': 'DASHBOARD.COMPLIANCE', 'group': benchmarkName },
                { 'field': `column_benchmark_${benchmarkTableCount + 1}_opportunities`, 'title': 'DASHBOARD.OPPORTUNITIES', 'group': benchmarkName },
                { 'field': `column_benchmark_${benchmarkTableCount + 1}_positive`, 'title': 'EVALUATION.POSITIVE_ACTIONS', 'group': benchmarkName },
              );

              res2.forEach((item, i) => {
                if (gridData.length == 0) {
                  var ventilation = { name: this.layoutService.translateText(this.asepticProcedures[0].value) }
                  var preparation = { name: this.layoutService.translateText(this.asepticProcedures[1].value) }
                  var manipulation = { name: this.layoutService.translateText(this.asepticProcedures[2].value) }
                  var dressing = { name: this.layoutService.translateText(this.asepticProcedures[3].value) }
                  var punctures = { name: this.layoutService.translateText(this.asepticProcedures[4].value) }
                  var contacts = { name: this.layoutService.translateText(this.asepticProcedures[5].value) }
                  var notSpecified = { name: this.layoutService.translateText(this.asepticProcedures[6].value) }

                  ventilation[`column_benchmark_${benchmarkTableCount + 1}_compliance`] = item.ventilationCompliance == -1 ? "N/A" : item.ventilationCompliance;
                  ventilation[`column_benchmark_${benchmarkTableCount + 1}_opportunities`] = item.ventilationOpportunities;
                  ventilation[`column_benchmark_${benchmarkTableCount + 1}_positive`] = item.ventilationPositives;

                  preparation[`column_benchmark_${benchmarkTableCount + 1}_compliance`] = item.preparationCompliance == -1 ? "N/A" : item.preparationCompliance;
                  preparation[`column_benchmark_${benchmarkTableCount + 1}_opportunities`] = item.preparationOpportunities;
                  preparation[`column_benchmark_${benchmarkTableCount + 1}_positive`] = item.preparationPositives;

                  manipulation[`column_benchmark_${benchmarkTableCount + 1}_compliance`] = item.manipulationCompliance == -1 ? "N/A" : item.manipulationCompliance;
                  manipulation[`column_benchmark_${benchmarkTableCount + 1}_opportunities`] = item.manipulationOpportunities;
                  manipulation[`column_benchmark_${benchmarkTableCount + 1}_positive`] = item.manipulationPositives;

                  dressing[`column_benchmark_${benchmarkTableCount + 1}_compliance`] = item.dressingCompliance == -1 ? "N/A" : item.dressingCompliance;
                  dressing[`column_benchmark_${benchmarkTableCount + 1}_opportunities`] = item.dressingOpportunities;
                  dressing[`column_benchmark_${benchmarkTableCount + 1}_positive`] = item.dressingPositives;

                  punctures[`column_benchmark_${benchmarkTableCount + 1}_compliance`] = item.puncturesCompliance == -1 ? "N/A" : item.puncturesCompliance;
                  punctures[`column_benchmark_${benchmarkTableCount + 1}_opportunities`] = item.puncturesOpportunities;
                  punctures[`column_benchmark_${benchmarkTableCount + 1}_positive`] = item.puncturesPositives;

                  contacts[`column_benchmark_${benchmarkTableCount + 1}_compliance`] = item.contactCompliance == -1 ? "N/A" : item.contactCompliance;
                  contacts[`column_benchmark_${benchmarkTableCount + 1}_opportunities`] = item.contactOpportunities;
                  contacts[`column_benchmark_${benchmarkTableCount + 1}_positive`] = item.contactPositives;

                  notSpecified[`column_benchmark_${benchmarkTableCount + 1}_compliance`] = item.notSpecifiedCompliance == -1 ? "N/A" : item.notSpecifiedCompliance;
                  notSpecified[`column_benchmark_${benchmarkTableCount + 1}_opportunities`] = item.notSpecifiedOpportunities;
                  notSpecified[`column_benchmark_${benchmarkTableCount + 1}_positive`] = item.notSpecifiedPositives;

                  gridData.push(ventilation, preparation, manipulation, dressing, punctures, contacts, notSpecified);
                } else {
                  this.asepticProcedures.forEach(asepticProcedure => {
                    if (asepticProcedure.checked) {
                      switch (asepticProcedure.id) {
                        case 1:
                          let ventilationIndex = gridData.findIndex(item => item.name == this.layoutService.translateText(this.asepticProcedures[0].value));
                          if (ventilationIndex != -1) {
                            gridData[ventilationIndex][`column_benchmark_${benchmarkTableCount + 1}_compliance`] = item.ventilationCompliance == -1 ? "N/A" : item.ventilationCompliance;
                            gridData[ventilationIndex][`column_benchmark_${benchmarkTableCount + 1}_opportunities`] = item.ventilationOpportunities;
                            gridData[ventilationIndex][`column_benchmark_${benchmarkTableCount + 1}_positive`] = item.ventilationPositives;
                          } else {
                            var ventilation = { name: this.layoutService.translateText(this.asepticProcedures[0].value) }
                            ventilation[`column_benchmark_${benchmarkTableCount + 1}_compliance`] = item.ventilationCompliance == -1 ? "N/A" : item.ventilationCompliance;
                            ventilation[`column_benchmark_${benchmarkTableCount + 1}_opportunities`] = item.ventilationOpportunities;
                            ventilation[`column_benchmark_${benchmarkTableCount + 1}_positive`] = item.ventilationPositives;

                            gridData.unshift(ventilation);
                          }
                          break;
                        case 2:
                          let preparationIndex = gridData.findIndex(item => item.name == this.layoutService.translateText(this.asepticProcedures[1].value));
                          if (preparationIndex != -1) {
                            gridData[preparationIndex][`column_benchmark_${benchmarkTableCount + 1}_compliance`] = item.preparationCompliance == -1 ? "N/A" : item.preparationCompliance;
                            gridData[preparationIndex][`column_benchmark_${benchmarkTableCount + 1}_opportunities`] = item.preparationOpportunities;
                            gridData[preparationIndex][`column_benchmark_${benchmarkTableCount + 1}_positive`] = item.preparationPositives;
                          } else {
                            var preparation = { name: this.layoutService.translateText(this.asepticProcedures[1].value) }
                            preparation[`column_benchmark_${benchmarkTableCount + 1}_compliance`] = item.preparationCompliance == -1 ? "N/A" : item.preparationCompliance;
                            preparation[`column_benchmark_${benchmarkTableCount + 1}_opportunities`] = item.preparationOpportunities;
                            preparation[`column_benchmark_${benchmarkTableCount + 1}_positive`] = item.preparationPositives;

                            gridData.splice(1, 0, preparation);
                          }
                          break;
                        case 3:
                          var manipulationIndex = gridData.findIndex(item => item.name == this.layoutService.translateText(this.asepticProcedures[2].value));
                          if (manipulationIndex != -1) {
                            gridData[manipulationIndex][`column_benchmark_${benchmarkTableCount + 1}_compliance`] = item.manipulationCompliance == -1 ? "N/A" : item.manipulationCompliance;
                            gridData[manipulationIndex][`column_benchmark_${benchmarkTableCount + 1}_opportunities`] = item.manipulationOpportunities;
                            gridData[manipulationIndex][`column_benchmark_${benchmarkTableCount + 1}_positive`] = item.manipulationPositives;
                          } else {
                            var manipulation = { name: this.layoutService.translateText(this.asepticProcedures[2].value) }
                            manipulation[`column_benchmark_${benchmarkTableCount + 1}_compliance`] = item.manipulationCompliance == -1 ? "N/A" : item.manipulationCompliance;
                            manipulation[`column_benchmark_${benchmarkTableCount + 1}_opportunities`] = item.manipulationOpportunities;
                            manipulation[`column_benchmark_${benchmarkTableCount + 1}_positive`] = item.manipulationPositives;

                            gridData.splice(2, 0, manipulation);
                          }
                          break;
                        case 4:
                          var dressingIndex = gridData.findIndex(item => item.name == this.layoutService.translateText(this.asepticProcedures[3].value));
                          if (dressingIndex != -1) {
                            gridData[dressingIndex][`column_benchmark_${benchmarkTableCount + 1}_compliance`] = item.dressingCompliance == -1 ? "N/A" : item.dressingCompliance;
                            gridData[dressingIndex][`column_benchmark_${benchmarkTableCount + 1}_opportunities`] = item.dressingOpportunities;
                            gridData[dressingIndex][`column_benchmark_${benchmarkTableCount + 1}_positive`] = item.dressingPositives;
                          } else {
                            var dressing = { name: this.layoutService.translateText(this.asepticProcedures[3].value) }
                            dressing[`column_benchmark_${benchmarkTableCount + 1}_compliance`] = item.dressingCompliance == -1 ? "N/A" : item.dressingCompliance;
                            dressing[`column_benchmark_${benchmarkTableCount + 1}_opportunities`] = item.dressingOpportunities;
                            dressing[`column_benchmark_${benchmarkTableCount + 1}_positive`] = item.dressingPositives;

                            gridData.splice(3, 0, dressing);
                          }
                          break;
                        case 5:
                          var punctureIndex = gridData.findIndex(item => item.name == this.layoutService.translateText(this.asepticProcedures[4].value));
                          if (punctureIndex != -1) {
                            gridData[punctureIndex][`column_benchmark_${benchmarkTableCount + 1}_compliance`] = item.puncturesCompliance == -1 ? "N/A" : item.puncturesCompliance;
                            gridData[punctureIndex][`column_benchmark_${benchmarkTableCount + 1}_opportunities`] = item.puncturesOpportunities;
                            gridData[punctureIndex][`column_benchmark_${benchmarkTableCount + 1}_positive`] = item.puncturesPositives;
                          } else {
                            var punctures = { name: this.layoutService.translateText(this.asepticProcedures[4].value) }
                            punctures[`column_benchmark_${benchmarkTableCount + 1}_compliance`] = item.puncturesCompliance == -1 ? "N/A" : item.puncturesCompliance;
                            punctures[`column_benchmark_${benchmarkTableCount + 1}_opportunities`] = item.puncturesOpportunities;
                            punctures[`column_benchmark_${benchmarkTableCount + 1}_positive`] = item.puncturesPositives;

                            gridData.splice(4, 0, punctures);
                          }
                          break;
                        case 6:
                          var contactIndex = gridData.findIndex(item => item.name == this.layoutService.translateText(this.asepticProcedures[5].value));
                          if (contactIndex != -1) {
                            gridData[contactIndex][`column_benchmark_${benchmarkTableCount + 1}_compliance`] = item.contactCompliance == -1 ? "N/A" : item.contactCompliance;
                            gridData[contactIndex][`column_benchmark_${benchmarkTableCount + 1}_opportunities`] = item.contactOpportunities || 0;
                            gridData[contactIndex][`column_benchmark_${benchmarkTableCount + 1}_positive`] = item.contactPositives || 0;
                          } else {
                            var contacts = { name: this.layoutService.translateText(this.asepticProcedures[5].value) }
                            contacts[`column_benchmark_${benchmarkTableCount + 1}_compliance`] = item.contactCompliance == -1 ? "N/A" : item.contactCompliance;
                            contacts[`column_benchmark_${benchmarkTableCount + 1}_opportunities`] = item.contactOpportunities || 0;
                            contacts[`column_benchmark_${benchmarkTableCount + 1}_positive`] = item.contactPositives || 0;

                            gridData.splice(5, 0, contacts);
                          }
                          break;
                        case 7:
                          var notSpecifiedIndex = gridData.findIndex(item => item.name == this.layoutService.translateText(this.asepticProcedures[6].value));
                          if (notSpecifiedIndex != -1) {
                            gridData[notSpecifiedIndex][`column_benchmark_${benchmarkTableCount + 1}_compliance`] = item.notSpecifiedCompliance == -1 ? "N/A" : item.notSpecifiedCompliance;
                            gridData[notSpecifiedIndex][`column_benchmark_${benchmarkTableCount + 1}_opportunities`] = item.notSpecifiedOpportunities || 0;
                            gridData[notSpecifiedIndex][`column_benchmark_${benchmarkTableCount + 1}_positive`] = item.notSpecifiedPositives || 0;
                          } else {
                            var notSpecified = { name: this.layoutService.translateText(this.asepticProcedures[6].value) }
                            notSpecified[`column_benchmark_${benchmarkTableCount + 1}_compliance`] = item.notSpecifiedCompliance == -1 ? "N/A" : item.notSpecifiedCompliance;
                            notSpecified[`column_benchmark_${benchmarkTableCount + 1}_opportunities`] = item.notSpecifiedOpportunities || 0;
                            notSpecified[`column_benchmark_${benchmarkTableCount + 1}_positive`] = item.notSpecifiedPositives || 0;

                            gridData.push(notSpecified);
                          }
                          break;
                      }
                    }
                  });
                }
              });
            }
          });
        }

        if (asepticProceduresArray.isBenchmark) {
          benchmarkTableCount += 1;
        } else {
          filterTableCount += 1;
        }

        this.asepticProcedures.forEach(procedure => {
          if (!procedure.checked) {
            gridData = gridData.filter(item => item.name != this.layoutService.translateText(procedure.value));
          }
        });

        this.results[chartIndex].gridData = gridData;
        this.results[chartIndex].fields = fields;
        this.results[chartIndex].benchmarkFields = benchmarkFields;
        this.results[chartIndex].resultChart = chart;

        

        setTimeout(() => {
          let complianceChart = this.compliance.charts.get(chartIndex);
          if (complianceChart) {
            complianceChart.chartDatamani();
          }
          this.compliance.setComplianceFields(this.results[chartIndex], 6, 2);
          this.compliance.setFilters(this.filters.toArray());
          
          if (index == res.length - 1) {
            this.compliance.resultsLoader.next(cloneDeep(this.results));
            if (this.exportTag) {
              this.exportTag.results = Object.assign([], this.results);
            }
          }
          
        }, 500);
      });
      this.evaluationLoaded = true;
      setTimeout(() => { this.initializeFilters(); }, 1000);

    }, 1000);

    
  }

  shouldHideBenchmarkDataByResponse(complianceList) {
    return complianceList.some(item => item.isBenchmark);
  }

  adjustResponseForEnvironment(res) {
    if (!this.isDesktop && res.length >= 2) {
      let spliceCount = 0;
      let idx = 1;
      res.forEach((asepticProceduresArray: any, index) => {
        if (index === 1) {
          if (asepticProceduresArray.isBenchmark === false) {
            spliceCount++;
          } else {
            idx = 2;
          }
        } else if (index === 2 || index === 3) {
          spliceCount++;
        }
      });
      return res.splice(idx, spliceCount);
    }
    return res;
  }

  initializeFilters() {
    this.selectedSeries = [];
    this.filters.forEach((filter, index) => {
      filter.visible = true;
    });

    this.evaluationService.getObserveEvaluationSeries(this.userID, "aseptic procedure").subscribe((seriesData: any) => {
      if (!seriesData || seriesData.selectedSeries == null) {
        this.layoutService.showLoader = false;
        return;
      }

      this.selectedSeries = JSON.parse(seriesData.selectedSeries);
      if (this.selectedSeries.length == 0) {
        this.layoutService.showLoader = false;
        return;
      }

      let chartSeries = JSON.parse(seriesData.selectedSeries);

      setTimeout(() => {
        chartSeries.forEach(serie => {
          if(typeof serie === 'number'){
              this.charts.forEach((chart) => {
                this.compliance.toggleVisibility(chart.chartId, {index: serie });
                chart.internalToggleSerie({ index: serie });
              });
          }else{
            let chart = this.charts.find(c => c.chartId === serie.chartId);
            if(!chart) return;
            serie.series.forEach((serie) => {
              chart.internalToggleSerie({ index: serie });
              this.compliance.toggleVisibility(chart.chartId, {index: serie });
            });
            this.filters.forEach((filter, index) => {
              if (index != serie.series) return;
              if (filter.visible == undefined) filter.visible = true;
              filter.visible = !filter.visible;
            });
          }
        });
      }, 1500);

    }, (error) => {
      this.layoutService.showLoader = false;
    }, () => {
      this.layoutService.showLoader = false;
    });
  }

  filterBenchmarkDataIfWardIsSelected(res): any {
    if (this.shouldHideBenchmarkData())
      return res.filter(item => !item.isBenchmark);
    else
      return res;
  }

  shouldHideBenchmarkData() {
    return this.anyWardIsSelected();
  }

  anyWardIsSelected() {
    for (let filterComponent of this.filters.toArray()) {
      if (filterComponent.isWardSelected()) {
        return true;
      }
    }
    return false;
  }

  onFilterRemoved(filterIndexToRemove: number) {
    const index = this.filterIndices.indexOf(filterIndexToRemove);

    if (index !== -1) {
      this.filterIndices.splice(index, 1);
    }

    this.showCompareCard = this.filterIndices.length > 1;
    this.compliance.showCompareCard = this.showCompareCard;
    if (this.userHasFilter) {
      this.layoutService.showLoader = true;
      setTimeout(() => { this.evaluate(true); }, 1000);
    }
  }

  emitData(valve) {
    if (valve.value) {
      this.appConfig.filterDetails = valve.value;
      this.appConfig.dropdownChanged = "changed";
    } else {
      this.appConfig.filterDetails = [];
    }
    switch (valve.key) {
      case 'back': this.router.navigate(['evaluation/observeObservation/statistical']); break; // this._location.back();
      case 'overallCompliance': this.router.navigate(['evaluation/observe/overallCompliance']); break;
      case 'asepticProcedure': this.router.navigate(['evaluation/observe/asepticProcedure']); break;
      case '5Moments': this.router.navigate(['evaluation/observe/fivemoments']); break;
      case 'individualData': this.router.navigate(['evaluation/observe/individualOverview']); break;
      case 'beforeAsepticProcedures': this.router.navigate(['evaluation/observe/StatisticsBeforeAsepticProcedures']); break;
      case 'comments': this.router.navigate(['evaluation/observe/comments']); break;
      case 'quota': this.router.navigate(['evaluation/observe/quota']); break;
      default: this.router.navigate(['evaluation/observeObservation/statistical']); break;
    }
  }

  resetFilters() {
    this.filterDetails = [this.filterDetails[0]];
    this.filterIndices = [0];
    this.filters.toArray()[0].resetFilter(true);
    this.asepticProcedures.forEach(procedure => procedure.checked = true);
    this.applyFiltersAndUpdateAsepticProceduresChecked();
    this.layoutService.showLoader = true;
    var seriesData = {
      userId: this.userID,
      complianceType: "aseptic procedure",
      selectedSeries: null
    };

    this.evaluationService.updateObserveEvaluationSeries(seriesData).subscribe(() => { 
      setTimeout(() => { this.evaluate(true); }, 1500);
    }, () => { }, () => { });

  }

  updateCheckboxState(taskId: string, isChecked: boolean) {
    this.layoutService.showLoader = true;
    this.asepticProcedures.find(m => m.id === taskId).checked = isChecked;
    this.applyFiltersAndUpdateAsepticProceduresChecked();
    setTimeout(() => { this.evaluate(true); }, 1000);
  }

  private applyFiltersAndUpdateAsepticProceduresChecked() {
    let data = this.prepareDataForUpdateAsepticProceduresShown();
    this.updateAsepticProceduresShown(true, this.userID, data);
  }

  private prepareDataForUpdateAsepticProceduresShown() {
    const proceduresChecked = this.asepticProcedures.filter(procedure => procedure.checked).map(procedure => procedure.id);
    let data = {
      filter: [],
      isBenchMark: true,
      asepticProceduresShown: proceduresChecked
    };

    this.filters.forEach((filter) => {
      let filterData = {
        startDate: filter.range.start,
        endDate: filter.range.end,
        instutionIDs: "",
        departmentID: "",
        wardID: "",
        professionalCategoryID: "",
        subprofessionalCategoryID: "",
        countryID: 0
      };

      if (this.roleId == 1 && filter.setCountry != 0) {
        filterData.countryID = filter.setCountry.countryID;
      }
      filterData = filter.assignData(filterData);
      data.filter.push(filterData);
    });
    return data;
  }

  originalFields: any[] = null;
  originalBenchmarkFields: any[] = null;
  selectedSeries: any[] = [];

  onSeriesClick(serie: any, resultIndex: number) {
    let chart = this.charts.find( c => c.chartId == serie.chartId);
    chart.series.get(serie.index).options.visible = serie.visible;

    this.filters.forEach((filter, index) => {
      if (index != serie.index) return;
      if (filter.visible == undefined) filter.visible = true;
      filter.visible = !filter.visible;
    });

    this.compliance.toggleVisibility(serie.chartId,serie);

    let visibilitySeries = [];

    this.charts.forEach((chart) => {
      let c = {
        chartId: chart.chartId,
        series: chart.series.map((s, index) => ({ series: s, index }))
                            .filter(s => s.series.options.visible === false)
                            .map(s => s.index)
      }
      visibilitySeries.push(c);
    })

    var seriesData = {
      userId: this.userID,
      complianceType: "aseptic procedure",
      selectedSeries: JSON.stringify(visibilitySeries)
    };

    this.evaluationService.updateObserveEvaluationSeries(seriesData).subscribe(() => { }, () => { }, () => { });
  }


  onFilterSaved() {
    // Buscar nombres duplicados y renombrar los duplicados
    const renamedFilters: string[] = [];
    var filters = this.filters.toArray();
    // Recorre desde el último hasta el primero
    for (let i = filters.length - 1; i >= 0; i--) {
      const currentName = filters[i].filterName?.trim() || '';
      for (let j = 0; j < filters.length; j++) {
        if (i !== j && currentName && currentName === (filters[j].filterName?.trim() || '')) {
          // Si hay coincidencia, renombra el actual
          const translatedFilterName = this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (i + 1);
          filters[i].filterName = translatedFilterName;
          filters[i].setFilterName = translatedFilterName;          
          renamedFilters.push(translatedFilterName);
          break;
        }
      }
    }

    if (renamedFilters.length > 0) {
        const f = renamedFilters[renamedFilters.length - 1];
        const msg = `${this.layoutService.translateText('EVALUATION.FILTER_DUPLICATED_NAME')} '${f}'.`;
        this.layoutService.showWarning(msg);
    }
    this.evaluate(true);
  }

  onRefreshClick(noDataFound: boolean) {
    if (noDataFound) {
      return;
    }

    this.evaluate(true);
  }

  saveSummarisedReport() {
    if (this.userHasFilter) {
      this.evaluate(false);
    }
  }

  trackLoop(index: number, item: any) {
    return item;
  }
}
